interface Props {
  label: string;
  value: string;
  onChange: (color: string) => void;
  presets?: string[];
}

const DEFAULT_PRESETS = [
  '#FF6B9D', '#FF3D7F', '#E85A8A', '#FFB5D1',
  '#FF4500', '#FFD700', '#32CD32', '#1E90FF',
  '#9B59B6', '#FFFFFF', '#000000', '#F5F5DC',
];

export function ColorPicker({ label, value, onChange, presets = DEFAULT_PRESETS }: Props) {
  return (
    <div>
      <label style={{
        display: 'block',
        fontSize: '0.85rem',
        fontWeight: 'bold',
        color: 'var(--color-text-secondary)',
        marginBottom: '4px',
      }}>
        {label}
      </label>
      <div style={{ display: 'flex', alignItems: 'center', gap: '8px', flexWrap: 'wrap' }}>
        <input
          type="color"
          value={value}
          onInput={(e) => onChange((e.target as HTMLInputElement).value)}
          style={{
            width: '36px',
            height: '36px',
            border: '2px solid var(--color-border)',
            borderRadius: '8px',
            cursor: 'pointer',
            padding: '2px',
          }}
        />
        <div style={{ display: 'flex', gap: '4px', flexWrap: 'wrap' }}>
          {presets.map((color) => (
            <button
              key={color}
              onClick={() => onChange(color)}
              title={color}
              style={{
                width: '24px',
                height: '24px',
                borderRadius: '50%',
                border: value === color ? '2px solid var(--color-primary)' : '2px solid var(--color-border)',
                background: color,
                cursor: 'pointer',
                padding: 0,
                boxShadow: value === color ? '0 0 0 2px white, 0 0 0 4px var(--color-primary)' : 'none',
              }}
            />
          ))}
        </div>
      </div>
    </div>
  );
}
